import type { Doc } from "building-types/doc";
import type { EntityRef } from "building-types/entities/entityRefTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { DocOption } from "building-types/options/optionSet";
import docGetEntity from "./docGetEntity";
import { docGetTableEntity } from "./docGetTableEntity";

export function docEntityHandleToEntityRef(doc: Doc, handle: DocEntityHandle): EntityRef | null {
  switch (handle.type) {
    case "ROOF_SIDE":
    case "FLOOR_PERIMETER_OPENING":
    case "CATALOG_ITEM":
    case "SHAPE":
    case "VERTEX":
    case "EDIT_MODE":
    case "GENERATED_ENTITY":
    case "AUTO_DIMENSION":
      return null;
    case "EDGE": {
      const parent = handle.parent;
      if (parent.type === "ROOM") {
        return doc.entityRefs[parent.id];
      }
      return null;
    }
    case "OPTION": {
      const option = docGetEntity(doc, handle) as DocOption;

      if (!option?.parentId) {
        return null;
      }

      return doc.entityRefs[option.parentId];
    }
    case "SETTINGS": {
      const settings = docGetTableEntity(doc, handle);

      if (!settings?.parentId) {
        return null;
      }

      return doc.entityRefs[settings.parentId];
    }
    default:
      return doc.entityRefs[handle.id];
  }
}
